import React, { memo } from 'react';
import { Table, Typography, Iconography, Functions as CommonFunctions } from 'fmc-digital-common';
import { Box, HStack, VStack, useBreakpointValue } from 'native-base';
import { docTableHeadList } from './docTableHeadList';
import Functions from '../../../utils/Functions';
export const DocumentTable = /*#__PURE__*/memo(({
  docTableList
}) => {
  const isSmallScreenView = useBreakpointValue({
    base: true,
    sm: false,
    md: false,
    lg: false
  });
  return /*#__PURE__*/React.createElement(Table, {
    tableHeadList: docTableHeadList
  }, /*#__PURE__*/React.createElement(VStack, null, docTableList?.map(({
    documentName,
    createdDate
  }, index) => /*#__PURE__*/React.createElement(HStack, {
    key: index,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: index % 2 === 0 ? 'white.500' : 'white.800',
    borderColor: 'lightBlue.400',
    borderBottomWidth: 1
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: 'center',
    width: {
      base: 162,
      md: 200
    },
    paddingX: 2,
    paddingY: 3
  }, /*#__PURE__*/React.createElement(Box, {
    mr: 1
  }, /*#__PURE__*/React.createElement(Iconography, {
    name: Functions.getIconName(CommonFunctions.getFileTypeBasedOnName(documentName)),
    size: 24,
    color: "review.500"
  })), /*#__PURE__*/React.createElement(Typography, {
    width: {
      base: 150,
      md: 200
    },
    fontWeight: 400,
    color: 'review.500',
    maxW: '95%',
    accessibilityLabel: "document name",
    accessibilityRole: "text",
    paddingRight: 2
  }, Functions.truncateText(documentName, isSmallScreenView ? 13 : 37))), /*#__PURE__*/React.createElement(Typography, {
    fontWeight: 400,
    color: 'review.500',
    width: {
      base: 150,
      md: 200
    },
    accessibilityLabel: "document uploaded time",
    accessibilityRole: "text",
    paddingX: 2
  }, Functions.dateFormater(createdDate))))));
});
//# sourceMappingURL=index.js.map